export function routeForUnityRoles(roles = []) {
  const assigned = new Set(Array.isArray(roles) ? roles : []);
  if (assigned.has("download_recipient")) {
    return assigned.size === 1 ? "/unity/downloads" : "/access-pending?reason=product-role";
  }
  const hasLearner = assigned.has("learner");
  const hasStaffRole = assigned.has("admin") || assigned.has("facilitator");

  if (hasLearner && hasStaffRole) {
    return "/access-pending?reason=product-role";
  }
  if (hasLearner) return "/unity/learner";
  if (assigned.has("facilitator")) return "/unity/facilitator";
  if (assigned.has("funder")) return "/unity/funder";
  if (assigned.has("supervisor")) return "/unity/supervisor";
  if (assigned.has("admin")) return "/unity/admin";
  return "/access-pending?reason=product-role";
}

export function routeForPreAuditRoles(roles = []) {
  const assigned = Array.from(new Set(
    (Array.isArray(roles) ? roles : [])
      .map((role) => String(role || "").trim())
      .filter(Boolean),
  ));
  if (assigned.length !== 1) {
    return "/access-pending?reason=product-role";
  }
  if (assigned[0] === "reviewer") return "/pre-audit/reviewer";
  if (assigned[0] === "supplier") return "/pre-audit/supplier";
  // Management access belongs to a Tenant Administrator and is routed above.
  return "/access-pending?reason=product-role";
}

export function routeForAccessContext(context) {
  const hasPlatform = context?.platform?.enabled === true;
  const tenant = context?.activeTenant;
  const hasTenant = Boolean(tenant);
  const isTenantAdmin = tenant?.tenantRole === "tenant_admin";
  if (hasPlatform) return "/platform-admin/dashboard";
  if (isTenantAdmin) return "/tenant-admin/dashboard";
  if (hasTenant && tenant?.tenantRole === "tenant_user") {
    const systems = Array.isArray(tenant.systems) ? tenant.systems : [];
    const opportunityProduct = systems.find(
      (product) => product?.key === "talentLenz" &&
        Array.isArray(product.roles) &&
        product.roles.length === 1 &&
        product.roles.includes("opportunity_user"),
    );
    if (opportunityProduct) {
      // A learner can retain their applicant role after enrolling in Unity.
      const unityProduct = systems.find((product) => product?.key === "unityLearning");
      if (unityProduct?.roles?.length === 1 && unityProduct.roles[0] === "learner") {
        return "/unity/learner";
      }
      return "/opportunity-page";
    }
    if (systems.length === 0) {
      return "/access-pending?reason=system-role";
    }
    if (systems.length !== 1) {
      return "/systems";
    }
    const product = systems[0];
    if (product?.key === "unityLearning") {
      return routeForUnityRoles(product.roles);
    }
    if (product?.key === "preAudit") {
      const productRoute = routeForPreAuditRoles(product.roles);
      return productRoute.startsWith("/pre-audit/")
        ? "/systems"
        : productRoute;
    }
    return product?.launchRoute || "/systems";
  }
  return "/access-pending";
}

export const APPLICANT_APPLICATION_ROUTE = "/application/apply";

export const APPLICANT_WORKSPACE_ROUTE = "/workspace";

export function routeAfterCentralLogin(context) {
  const route = routeForAccessContext(context);
  if (route !== "/access-pending") return route;
  if (context?.activeTenant) return APPLICANT_WORKSPACE_ROUTE;
  return APPLICANT_WORKSPACE_ROUTE;
}

export function routeAfterTenantSwitch(context, currentPathname = "") {
  const tenant = context?.activeTenant;
  if (tenant?.tenantRole === "tenant_admin" &&
      String(currentPathname).startsWith("/tenant-admin")) {
    return "/tenant-admin/dashboard";
  }
  return routeForAccessContext(context);
}
